import type { Type } from '@angular/core';


export abstract class AuthAccessDialogResolverService {
  abstract getUnauthorizedDialog(options: { statusCode?: number; }): Type<any> | null; // `null` means use default.
  abstract getUnauthorizedByPolicyFollowupDialog(): Type<any> | null // `null` means use default.
  abstract getAccessBlockedDialog(): Type<any> | null; // `null` means use default.
}
